import "core-js/modules/es.array.is-array.js";
/**
 * Custom isArray type-guard that uses unknown[] instead of any[]
 */
export function isArray(value) {
  return Array.isArray(value);
}